/**
 * SGI HRMS — Service Worker registration + update flow.
 * - Registers /sw.js once page load is complete (CRA-style)
 * - When a new SW is found, posts SKIP_WAITING and reloads the page so users
 *   always run the latest deployed code (critical for HRMS — no stale UI).
 * - Disabled when running inside the Emergent visual-edit iframe (window.self !== window.top)
 *   so Cypress / Playwright tests aren't disrupted.
 */
export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  // Avoid registering inside Emergent visual-edit iframe
  try { if (window.self !== window.top) return; } catch { return; }

  // Only register on http(s); skip on plain http (some preview env edge cases)
  const isSecure = window.location.protocol === 'https:' || window.location.hostname === 'localhost';
  if (!isSecure) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        // Update detected — auto-activate new SW + reload once
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              installing.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch(() => { /* registration failure is non-fatal */ });

    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  });
}
